export default __webpack_public_path__ + "static/Gaggenau-08-Regular-b4a875a87b014e16c33f091e68a329f5.ttf";